/*
  customsirge_header.js
  Purpose: Header scroll state (transparent -> brand blue after scrolling) + mobile nav toggle.
  Owns:    [data-customsirge-header]. No deps. Defer-loaded.
  Owner:   agent-p1-header / feat/redesign-foundation   Updated: 2026-07-02
*/
(function () {
  function init() {
    var header = document.querySelector('[data-customsirge-header]');
    if (!header) return;
    var overlay = header.getAttribute('data-overlay') === 'true';

    function onScroll() {
      if (!overlay) return; // solid headers stay solid
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }
    if (overlay) {
      window.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });
      onScroll();
    }

    var toggles = header.querySelectorAll('[data-customsirge-nav-toggle]');
    var closers = header.querySelectorAll('[data-customsirge-nav-close]');

    function setNavOpen(open) {
      header.setAttribute('data-nav-open', String(open));
      for (var i = 0; i < toggles.length; i++) {
        toggles[i].setAttribute('aria-expanded', String(open));
      }
      document.body.style.overflow = open ? 'hidden' : '';
    }

    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', function () {
        setNavOpen(header.getAttribute('data-nav-open') !== 'true');
      });
    }
    for (var j = 0; j < closers.length; j++) {
      closers[j].addEventListener('click', function () { setNavOpen(false); });
    }

    // Mobile drawer: chevron toggles a nav item's child sublist open/closed.
    var subToggles = header.querySelectorAll('[data-customsirge-submenu-toggle]');
    for (var k = 0; k < subToggles.length; k++) {
      subToggles[k].addEventListener('click', function () {
        var item = this.closest('[data-customsirge-nav-item]');
        if (!item) return;
        var open = item.getAttribute('data-open') !== 'true';
        item.setAttribute('data-open', String(open));
        this.setAttribute('aria-expanded', String(open));
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.getAttribute('data-nav-open') === 'true') setNavOpen(false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
